/* global MEDIA_ROOT */

import React from 'react';

const ArrowLeftLarger = props => (
  <img {...props} src={`${MEDIA_ROOT}/icons/icn_arrowleftlarger.svg`} alt="Arrow left" />
);

export default ArrowLeftLarger;



// WEBPACK FOOTER //
// ./app/src/components/Iconography/components/ArrowLeftLarger/index.jsx